import { Ribbon } from '@/data/types/Product';

export const excludeRibbons = ['DPD_', 'DPS_', 'DPV_'];

export const isExcludeRibbon = (identifier: string) =>
	excludeRibbons.some((ribbon) => identifier.startsWith(ribbon));

export const mergeRibbonsForProduct = (ribbons: Ribbon[]) => {
	const sapOferta = ribbons.filter((item) => item.identifier === 'DPT_SAPOferta');
	const otherRibbons = ribbons.filter((item) => !isExcludeRibbon(item.identifier));
	const sortedRibbons = [...sapOferta, ...otherRibbons];

	const uniqueRibbons = sortedRibbons.filter(
		(ribbon, index, self) => index === self.findIndex((t) => t.value === ribbon.value)
	);

	return uniqueRibbons;
};
